import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup, NonNullableFormBuilder } from '@angular/forms';
import { listenFormValue$ } from '@shared/utils/helpers';
import { NavigationService } from '@shared/utils/services';
import { Table } from 'primeng/table';
import { debounceTime, defer, Observable, tap } from 'rxjs';
import { SearchControls, SearchValue } from './table-header.model';

@Injectable({
  providedIn: 'root',
})
export class TableHeaderService {
  private readonly fb = inject(NonNullableFormBuilder);
  private readonly navigationService = inject(NavigationService);

  public createSearchForm<TStatus extends string | number>(
    defaults?: SearchValue<TStatus>,
  ): FormGroup<SearchControls<TStatus>> {
    return this.fb.group<SearchControls<TStatus>>({
      search: this.fb.control(defaults?.search ?? null),
      status: this.fb.control(defaults?.status ?? null),
    });
  }

  public searchFormChanges$<TStatus extends string | number>(
    form: FormGroup<SearchControls<TStatus>>,
    table: Table | undefined,
    destroyRef: DestroyRef,
  ): Observable<void> {
    return defer(() =>
      listenFormValue$(form).pipe(
        debounceTime(300),
        tap(({ search, status }) => {
          table?.filterGlobal(search ?? '', 'contains');
          table?.filter(status, 'status', 'equals');

          this.navigationService.updateQueryParams({ search, status });
        }),
        takeUntilDestroyed(destroyRef),
      ),
    );
  }
}
